import { Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import Loader from "../loader/Loader";
import "./index.less";

type CancelSubscriptionConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  cancelSubscription: () => void;
  isLoading?: boolean;
};

const CancelSubscriptionConfirmationModalComponent: React.FC<CancelSubscriptionConfirmationModalProps> = ({
  isOpen,
  onClose,
  cancelSubscription,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!isLoading && onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-24">{t("cancel-subscription-modal-title")}</Typography.Text>
        </div>
        <div className="bottom-modal-body mt-10">
          <button className="bottom-modal-button mt-14" onClick={cancelSubscription} disabled={isLoading}>
            {isLoading ? (
              <Loader inline size="small" />
            ) : (
              <Typography.Text className="bottom-modal-button-title">{t("yes-cancel-subscription")}</Typography.Text>
            )}
          </button>

          <button className="bottom-modal-cancel-button" onClick={onClose} disabled={isLoading}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionConfirmationModalComponent;
